import React from "react"
import Home from "./home/index"

export const Main: React.FC<{}> = (): JSX.Element => {
  return <Home />
}
export default Main
